(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ww-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ww-product-carousel')) {
    class WWProductCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.track = this.querySelector('.ww-product-carousel__track');
        this.slides = Array.from(this.querySelectorAll('.ww-product-carousel__slide'));
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dotsContainer = this.querySelector('[data-carousel-dots]');
        this.status = this.querySelector('[data-carousel-status]');
        this.pageLabel = this.dataset.pageLabel || 'Product group';

        if (!this.track || this.slides.length < 2) return;

        this.dataset.initialized = 'true';
        this.currentPage = 0;
        this.pageCount = 0;
        this.itemsPerPage = 1;
        this.scrollFrame = null;

        this.handlePrevious = () => this.scrollToPage(this.currentPage - 1);
        this.handleNext = () => this.scrollToPage(this.currentPage + 1);
        this.handleScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.updateState();
            this.scrollFrame = null;
          });
        };
        this.handleKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          if (event.key === 'ArrowLeft') this.handlePrevious();
          if (event.key === 'ArrowRight') this.handleNext();
        };

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.track.addEventListener('keydown', this.handleKeydown);

        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.track);
        this.refresh();
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.track?.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      getSlidePosition(slide) {
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        return slideRect.left - trackRect.left + this.track.scrollLeft;
      }

      refresh() {
        const firstSlide = this.slides[0];
        if (!firstSlide) return;

        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap) || 0;
        const slideWidth = firstSlide.getBoundingClientRect().width;
        const nextItemsPerPage = Math.max(1, Math.round((this.track.clientWidth + gap) / (slideWidth + gap)));
        const nextPageCount = Math.ceil(this.slides.length / nextItemsPerPage);

        if (nextItemsPerPage !== this.itemsPerPage || nextPageCount !== this.pageCount) {
          this.itemsPerPage = nextItemsPerPage;
          this.pageCount = nextPageCount;
          this.renderDots();
        }

        this.classList.toggle('is-scrollable', this.track.scrollWidth - this.track.clientWidth > 2);
        this.updateState();
      }

      renderDots() {
        if (!this.dotsContainer) return;

        this.dotsContainer.replaceChildren();
        for (let index = 0; index < this.pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ww-product-carousel__dot';
          dot.setAttribute('aria-label', `${this.pageLabel} ${index + 1}`);
          dot.addEventListener('click', () => this.scrollToPage(index));
          this.dotsContainer.append(dot);
        }
      }

      scrollToPage(page) {
        const nextPage = Math.max(0, Math.min(page, this.pageCount - 1));
        const targetIndex = Math.min(nextPage * this.itemsPerPage, this.slides.length - 1);
        const targetSlide = this.slides[targetIndex];
        if (!targetSlide) return;

        this.track.scrollTo({
          left: this.getSlidePosition(targetSlide),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      updateState() {
        const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(this.getSlidePosition(slide) - this.track.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.currentPage = Math.min(this.pageCount - 1, Math.round(nearestIndex / this.itemsPerPage));
        if (this.track.scrollLeft >= maximumScroll - 2) this.currentPage = this.pageCount - 1;

        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;

        this.dotsContainer?.querySelectorAll('.ww-product-carousel__dot').forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.currentPage ? 'true' : 'false');
        });

        if (this.status && this.pageCount > 1) {
          this.status.textContent = `${this.pageLabel} ${this.currentPage + 1} / ${this.pageCount}`;
        }
      }
    }

    customElements.define('ww-product-carousel', WWProductCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
